package pwgs.ui.scenes.playererrorsscene


class PlayerErrorsControllerFe(props: PlayerErrorsSceneProps, scene: MPlayerErrorsScene) : APlayerErrorsControllerFe(props, scene) {

    override fun createInitialModel() : PlayerErrorsSceneModel {
        return PlayerErrorsSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }


}

